export default function Device ()
{
  const init = () =>
  {
    const ug = window.navigator.userAgent.toLowerCase();

    let version;

    this.isIPhone = (ug.indexOf('iphone') !== -1);
    this.isIPad = (ug.indexOf('ipad') !== -1);
    this.isIPod = (ug.indexOf('ipod') !== -1);
    this.isIOS = this.isIPhone || this.isIPad || this.isIPod;

    if (this.isIOS)
    {
      version = ug.match(/os\s+(\d+)_(\d+)(?:_(\d+))?\s+like\s+mac\s+os/i);

      if (version && version.length > 3)
      {
        this.iOSVersion = [version[1],
          version[2],
          (version[3] || 0)];
      }
      else
      {
        this.iOSVersion = [8, 1, 0];
      }
    }

    this.isAndroid = (ug.indexOf('android') !== -1);
    this.isAndroidPhone = this.isAndroid && (ug.indexOf('mobile') !== -1);
    this.isaAndroidTablet = this.isAndroid && (ug.indexOf('mobile') === -1);

    this.isBlackberry = (ug.indexOf('blackberry') !== -1) && (ug.indexOf('bb10') !== -1) && (ug.indexOf('rim') !== -1);
    this.isBlackberryPhone = this.isBlackberry && (ug.indexOf('tablet') === -1);
    this.isBlackberryTablet = this.isBlackberry && (ug.indexOf('tablet') !== -1);

    this.isWindows = (ug.indexOf('windows') !== -1);
    this.isWindowsPhone = this.isWindows && (ug.indexOf('phone') !== -1);
    this.isWindowsTablet = this.isWindows && ((ug.indexOf('touch') !== -1) && !this.isWindowsPhone);

    this.isFFOS = ((ug.indexOf('(mobile;') !== -1) || (ug.indexOf('(tablet;') !== -1)) && (ug.indexOf('; rv:') !== -1);
    this.isFFOSPhone = this.isFFOS && (ug.indexOf('mobile') !== -1);
    this.isFFOSTablet = this.isFFOS && (ug.indexOf('tablet') !== -1);

    this.isMeeGo = (ug.indexOf('meego') !== -1);
    this.isCordova = window.cordova && location.protocol === 'file:';
    this.isNodeWebkit = typeof(window.process) === 'object';

    this.isPhone = this.isIPhone || this.isIPod || this.isAndroid || this.isBlackberryPhone || this.isWindowsPhone || this.isFFOSPhone || this.isMeeGo;
    this.isTablet = this.isIPad || this.isaAndroidTablet || this.isBlackberryTablet || this.isWindowsTablet || this.isFFOSTablet;
    this.isMobile = this.isPhone || this.isTablet;
    this.isDesktop = !this.isMobile;

    this.isPortrait = ('innerWidth' in window && 'innerHeight' in window) ? ((window.innerHeight / window.innerWidth) > 1) : true;
    this.isLandscape = !this.isPortrait;

    this.isSupportsOrientation = ('onorientationchange' in window);
    this.isOrientationEvent = (this.isSupportsOrientation ? 'orientationchange' : 'resize');
  };

  init();
}